import "../../../assets/css/global.css";
// import { useState, useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faKey, faEdit } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";

// import TranslatorService from "../../../services/Translator/TranslatorService";
// import { useTranslation } from "react-i18next";

// import Swal from "sweetalert2";
// import { useKeycloak } from "@react-keycloak/web";

const AdminTemplate = () => {
  // const [modalNewUserOpen, setModalNewUserOpen] = useState(false);
  // const [modalEditUserOpen, setModalEditUserOpen] = useState(false);
  // const [isNewUser, setIsNewUser] = useState(true);
  // const [username, setUsername] = useState("");
  // const [userRole, setUserRole] = useState("");

  // const authUrl = process.env.REACT_APP_AUTH_API_URL;
  // const { keycloak } = useKeycloak();
  // const accessToken = keycloak.token;
  // const userInfo = {
  //   username: keycloak.tokenParsed.preferred_username,
  // };

  // const [users, setUsers] = useState({});

  // const { t } = useTranslation();

  // useEffect(() => {
  //   getAllUsers();
  // }, []);

  // const getAllUsers = async () => {
  //   try {
  //     const { data } = await axios.get(authUrl + "/users", {
  //       headers: {
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //     });

  //     setUsers(data);
  //   } catch (error) {
  //     console.error("Error fetching users:", error);
  //   }
  // };

  // const updateUserLockStatus = async (username, isLocked) => {
  //   return axios
  //     .patch(
  //       authUrl + "/user/" + username + "/is-locked",
  //       { isLocked: !isLocked },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //         },
  //       }
  //     )
  //     .then((response) => response.data)
  //     .catch((error) => {
  //       console.error("Erro na atualização do estado de lock: ", error);
  //       throw error;
  //     })
  //     .finally(() => {
  //       getAllUsers();
  //     });
  // };

  // const createUser = async (username, role, isLocked) => {
  //   const url = new URL("/user/create", authUrl);

  //   const user = {
  //     username: username,
  //     role: role,
  //     isLocked: isLocked,
  //   };

  //   return axios
  //     .post(url, user, {
  //       headers: {
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //     })
  //     .then((response) => response.data)
  //     .catch((error) => {
  //       if (
  //         error.response &&
  //         error.response.data &&
  //         error.response.data.message
  //       ) {
  //         showAlert(error.response.data.message);
  //       } else {
  //         showAlert("Ocorreu um erro inesperado.");
  //       }
  //     })
  //     .finally(() => {
  //       getAllUsers();
  //     });
  // };

  // const showAlert = (message) => {
  //   Swal.fire({
  //     icon: "error",
  //     title: "Erro",
  //     text: message,
  //   });
  // };

  // const updateUser = async (username, role) => {
  //   const url = new URL("/user/" + username + "/role", authUrl);

  //   try {
  //     const response = await axios.patch(
  //       url,
  //       { role: role },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //         },
  //       }
  //     );
  //     return response.data;
  //   } catch (error) {
  //     console.error("Erro ao atualizar o usuário:", error);
  //     throw error;
  //   } finally {
  //     getAllUsers();
  //   }
  // };

  // const handleFormSubmit = (e) => {
  //   e.preventDefault();

  //   if (isNewUser) {
  //     createUser(username, userRole, false);
  //   } else {
  //     updateUser(username, userRole);
  //   }

  //   closeModals();
  // };

  // const handleSwitchChange = (e, username) => {
  //   if (userInfo.username === username) {
  //     Swal.fire({
  //       title: t("profilePanel.error"),
  //       text: t("profilePanel.cannotChangeYourOwnUser"),
  //       icon: "error",
  //       confirmButtonText: "Ok",
  //     });
  //     return;
  //   }
  //   const isChecked = e.target.checked;
  //   setUsers(
  //     users.map((user) =>
  //       user.username === username ? { ...user, isLocked: !isChecked } : user
  //     )
  //   );
  //   updateUserLockStatus(username, isChecked);
  // };

  // const closeModals = () => {
  //   setModalNewUserOpen(false);
  //   setModalEditUserOpen(false);
  // };

  // const openModalNewUser = () => {
  //   setIsNewUser(true);
  //   setUsername("");
  //   setUserRole("");
  //   setModalNewUserOpen(true);
  // };

  // const openModalEditUser = (user) => {
  //   setIsNewUser(false);
  //   setUsername(user.username);
  //   setUserRole(user.role);
  //   setModalEditUserOpen(true);
  // };

  // useEffect(() => {
  //   if (modalNewUserOpen || modalEditUserOpen) {
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     document.body.style.overflow = "";
  //   }
  // }, [modalNewUserOpen, modalEditUserOpen]);

  // <>
  //   <div className="main d-flex flex-column vh-100">
  //     <div className="breadcrumb d-flex align-items-center flex-sh-0">
  //       <nav aria-label="breadcrumb">
  //         <ol className="breadcrumb">
  //           <li className="breadcrumb-item">
  //             <a href="#">
  //               <FontAwesomeIcon icon={faKey} />
  //               &ensp;
  //               <TranslatorService path="adminPanel.breadcrumb" />
  //             </a>
  //           </li>
  //         </ol>
  //       </nav>
  //     </div>
  //     <div className="flex-grow-1 overflow-auto pt-20">
  //       <div className="container p-4">
  //         <div className="row">
  //           <div className="col-12 col-titleSection">
  //             <h1>
  //               <TranslatorService path="adminPanel.title" />
  //             </h1>
  //             <p>
  //               <TranslatorService path="adminPanel.description" />
  //             </p>
  //             <button
  //               type="button"
  //               className="btn btn-primary mr-15"
  //               onClick={openModalNewUser}
  //             >
  //               <TranslatorService path="adminPanel.buttonCreateUser" />
  //             </button>
  //           </div>
  //         </div>
  //         <div className="row row-cols-1 row-cols-md-3 g-4">
  //           <div className="col-12 w-100p mt-50">
  //             <table className="table">
  //               <thead>
  //                 <tr>
  //                   <th scope="col">
  //                     <TranslatorService path="adminPanel.username" />
  //                   </th>
  //                   <th scope="col">
  //                     <TranslatorService path="adminPanel.typeUser" />
  //                   </th>
  //                   <th scope="col">
  //                     <TranslatorService path="adminPanel.permission" />
  //                   </th>
  //                   <th scope="col">
  //                     <TranslatorService path="adminPanel.actions" />
  //                   </th>
  //                 </tr>
  //               </thead>
  //               <tbody>
  //                 {users.length > 0 ? (
  //                   users.map((user) => (
  //                     <tr key={user.id}>
  //                       <th scope="row">{user.username}</th>
  //                       <td>{user.role}</td>
  //                       <td>
  //                         <div className="form-check form-switch">
  //                           <input
  //                             className="form-check-input"
  //                             type="checkbox"
  //                             id={`flexSwitchCheckDefault-${user.id}`}
  //                             checked={!user.isLocked}
  //                             onChange={(e) =>
  //                               handleSwitchChange(e, user.username)
  //                             }
  //                           />
  //                         </div>
  //                       </td>
  //                       <td>
  //                         <button
  //                           type="button"
  //                           className="btn btn-primary mr-15"
  //                           onClick={() =>
  //                             openModalEditUser({
  //                               username: user.username,
  //                               role: user.role,
  //                             })
  //                           }
  //                         >
  //                           <FontAwesomeIcon icon={faEdit} />
  //                         </button>
  //                       </td>
  //                     </tr>
  //                   ))
  //                 ) : (
  //                   <tr>
  //                     <td colSpan="4">
  //                       <TranslatorService path="adminPanel.usersNotFound" />
  //                     </td>
  //                   </tr>
  //                 )}
  //               </tbody>
  //             </table>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  //   {/* Modal de Criação de Usuário */}
  //   {modalNewUserOpen && (
  //     <>
  //       <div className="modal-backdrop fade show"></div>
  //       <div
  //         className="modal fade show"
  //         id="modalNewUser"
  //         tabIndex="-1"
  //         aria-labelledby="modalLabelNewUser"
  //         aria-hidden="true"
  //         style={{ display: "block" }}
  //       >
  //         <div className="modal-dialog">
  //           <div className="modal-content">
  //             <div className="modal-header">
  //               <h5 className="modal-title" id="modalLabelNewUser">
  //                 <TranslatorService path="adminPanel.newUser" />
  //               </h5>
  //               <button
  //                 type="button"
  //                 className="btn-close"
  //                 onClick={closeModals}
  //                 aria-label="Close"
  //               ></button>
  //             </div>
  //             <form onSubmit={handleFormSubmit}>
  //               <div className="modal-body">
  //                 <div className="form-floating mb-3">
  //                   <input
  //                     type="text"
  //                     className="form-control"
  //                     id="floatingInputUsername"
  //                     placeholder={t("adminPanel.nameSurname")}
  //                     value={username}
  //                     onChange={(e) => setUsername(e.target.value)}
  //                     required
  //                   />
  //                   <label htmlFor="floatingInputUsername">
  //                     <TranslatorService path="adminPanel.username" />{" "}
  //                     <small>(ex: {t("adminPanel.nameSurname")})</small>
  //                   </label>
  //                 </div>
  //                 <div className="mb-3">
  //                   <select
  //                     className="form-select"
  //                     aria-label={t("adminPanel.typeUser")}
  //                     id="selectRole"
  //                     value={userRole}
  //                     onChange={(e) => setUserRole(e.target.value)}
  //                     required
  //                   >
  //                     <option value="" disabled>
  //                       {t("adminPanel.typeUser")}
  //                     </option>
  //                     <option value="admin">admin</option>
  //                     <option value="superuser">superuser</option>
  //                     <option value="user">user</option>
  //                   </select>
  //                 </div>
  //               </div>
  //               <div className="modal-footer">
  //                 <button
  //                   type="button"
  //                   className="btn btn-secondary"
  //                   onClick={closeModals}
  //                 >
  //                   {t("adminPanel.close")}
  //                 </button>
  //                 <button type="submit" className="btn btn-primary">
  //                   {isNewUser
  //                     ? t("adminPanel.newUser")
  //                     : t("adminPanel.updateUser")}
  //                 </button>
  //               </div>
  //             </form>
  //           </div>
  //         </div>
  //       </div>
  //     </>
  //   )}

  //   {/* Modal de Edição de Usuário */}
  //   {modalEditUserOpen && (
  //     <>
  //       <div className="modal-backdrop fade show"></div>
  //       <div
  //         className="modal fade show"
  //         id="modalEditUser"
  //         tabIndex="-1"
  //         aria-labelledby="modalLabelEditUser"
  //         aria-hidden="true"
  //         style={{ display: "block" }}
  //       >
  //         <div className="modal-dialog">
  //           <div className="modal-content">
  //             <div className="modal-header">
  //               <h5 className="modal-title" id="modalLabelEditUser">
  //                 {t("adminPanel.editUser")}
  //               </h5>
  //               <button
  //                 type="button"
  //                 className="btn-close"
  //                 onClick={closeModals}
  //                 aria-label="Close"
  //               ></button>
  //             </div>
  //             <form onSubmit={handleFormSubmit}>
  //               <div className="modal-body">
  //                 <div className="form-floating mb-3">
  //                   <input
  //                     type="text"
  //                     className="form-control"
  //                     id="floatingInputUsernameEdit"
  //                     placeholder={t("adminPanel.nameSurname")}
  //                     value={username}
  //                     onChange={(e) => setUsername(e.target.value)}
  //                     required
  //                     disabled
  //                   />
  //                   <label htmlFor="floatingInputUsernameEdit">
  //                     {t("adminPanel.username")}{" "}
  //                     <small>(ex: {t("adminPanel.nameSurname")})</small>
  //                   </label>
  //                 </div>
  //                 <div className="mb-3">
  //                   <select
  //                     className="form-select"
  //                     aria-label={t("adminPanel.typeUser")}
  //                     id="selectRoleEdit"
  //                     value={userRole}
  //                     onChange={(e) => setUserRole(e.target.value)}
  //                     required
  //                   >
  //                     <option value="" disabled>
  //                       {t("adminPanel.typeUser")}
  //                     </option>
  //                     <option value="admin">admin</option>
  //                     <option value="superuser">superuser</option>
  //                     <option value="user">user</option>
  //                   </select>
  //                 </div>
  //               </div>
  //               <div className="modal-footer">
  //                 <button
  //                   type="button"
  //                   className="btn btn-secondary"
  //                   onClick={closeModals}
  //                 >
  //                   {t("adminPanel.close")}
  //                 </button>
  //                 <button type="submit" className="btn btn-primary">
  //                   {t("adminPanel.updateUser")}
  //                 </button>
  //               </div>
  //             </form>
  //           </div>
  //         </div>
  //       </div>
  //     </>
  //   )}
  // </>
  // abaixo um alerta simples que admin está indisponível no momento
  return (
    <div className="alert alert-warning" role="alert">
      <h4 className="alert-heading">Atualização em Progresso!</h4>
      <p>
        Estamos atualizando o painel de administração e ele pode ficar fora do
        ar temporariamente. Obrigado pela compreensão!
      </p>
    </div>
  );
};

export default AdminTemplate;
